var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveCreateGroupIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6519 16.6521H21.3039",
    stroke: "#42296E",
    strokeWidth: 1.67
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8608 2.6958H2.6958V21.3041H13.8608",
    stroke: "#42296E",
    strokeWidth: 1.67
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41748 6.41748H13.3956V10.1391H6.41748V6.41748Z",
    stroke: "#42296E",
    strokeWidth: 1.67
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41748 14H13.3956V17.7217H6.41748V14Z",
    stroke: "#42296E",
    strokeWidth: 1.67
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6519 21.3041H21.3039V5.02184L18.9779 2.6958L16.6519 5.02184V21.3041Z",
    stroke: "#42296E",
    strokeWidth: 1.67
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCreateGroupIcon);
export default __webpack_public_path__ + "static/media/active_create_group_icon.8932b44d280b0f017e18cd8df07d8d0d.svg";
export { ForwardRef as ReactComponent };